import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';
import Slide from '@mui/material/Slide';

const SlideTransition = (props) => {
  return <Slide {...props} direction="up" />;
};

const CustomSnackbar = ({ open, handleClose, message, severity = 'info', autoHideDuration = 3000 }) => {
  return (
    <Snackbar
      open={open}
      autoHideDuration={autoHideDuration}
      onClose={handleClose}
      TransitionComponent={SlideTransition}
      anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
    >
      <MuiAlert
        elevation={6}
        variant="filled"
        severity={severity}
        onClose={handleClose}
        sx={{
          zIndex: 2000,
          fontWeight: 500,
          borderRadius: 2,
          px: 2,
          py: 1,
          bgcolor: {
            success: '#4caf50',
            error: '#f44336',
            warning: '#ff9800',
            info: '#2196f3',
          }[severity],
          color: 'white',
        }}
      >
        {message}
      </MuiAlert>
    </Snackbar>
  );
};

export default CustomSnackbar;
